import React from "react";
import {
	Avatar,
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	ListItem,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const TheContextSeedBlog: React.FC = () => (
	<>
		<Flex
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height="100%"
			py={{ xs: "30px", sm: "40px", md: "60px", lg: "80px" }}
			h="100%"
			minH={{ xs: "400px", lg: "400px" }}
			maxH={{ xs: "400px", lg: "400px" }}
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/webp/theContext-bg.webp"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir={{ xs: "column", md: "row" }}
				columnGap="24px"
				rowGap="30px"
				alignItems={{ xs: "flex-start", md: "flex-start" }}
				px={{ xs: "14px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Flex flexDir="column" rowGap="16px">
					<Heading
						color="white"
						fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
						fontWeight="800"
						lineHeight={{ xs: "35px", lg: "83px" }}
					>
						#TheContext
					</Heading>
					{/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
				</Flex>
				<Box
					w="1.5px"
					h={{ md: "200px", lg: "300px", xl: "230px" }}
					bgColor="white"
					display={{ xs: "none", md: "block" }}
				/>
				<Box
					w={{ xs: "70%", sm: "60%" }}
					h="1.5px"
					bgColor="white"
					display={{ xs: "block", md: "none" }}
				/>
				<Flex flexDir="column" rowGap="8px">
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						Seed to IPO: A Venture Investor’s Perfect Dream
					</Heading>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Vineet Rai, Aavishkaar Group
					</Text>
				</Flex>
			</Container>
		</Flex>
		<Container maxW="container.xl" pb="80px" pt="40px">
			<Flex
				flexDir={{ xs: "column-reverse", md: "row" }}
				px={{ xs: "8px", md: "0px" }}
			>
				<Flex
					w={{ xs: "100%", md: "27%" }}
					mt={{ xs: "32px", md: "0px" }}
					flexDir="column"
					rowGap="16px"
					mr={{ xs: "0px", md: "40px" }}
					ml={{ xs: "0px", sm: "10px" }}
					mb={{ xs: "16px", md: "8px" }}
				>
					<Heading
						fontSize="22px"
						lineHeight="22px"
						textAlign={{ xs: "center", sm: "left" }}
					>
						Follow the Authors
					</Heading>
					<Box
						w="100%"
						h="1.5px"
						bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
						my="8px"
					/>
					{[
						{
							name: "Vineet Rai",
							position: " Founder, Aavishkaar Group",
							linkedin: "https://www.linkedin.com/in/vineet-rai-536160/",
							image:
								"https://static.levocdn.com/WGLBUT82/7095685755092677586.jpg",
						},
					].map((item, index) => (
						<Flex
							key={index}
							flexDir={{ xs: "column", sm: "row", md: "column" }}
							columnGap="20px"
							rowGap="16px"
						>
							<Flex
								flexDir="column"
								alignItems={{ xs: "center", sm: "flex-start" }}
								rowGap="8px"
							>
								<Box boxSize="95px" borderRadius="50%" overflow="hidden">
									<Avatar
										name={item.name}
										w="100%"
										h="100%"
										src={item.image}
										objectFit="cover"
									/>
								</Box>
								<Flex flexDir="column" rowGap="4px">
									<Heading
										variant="blogQuestion"
										textAlign={{ xs: "center", sm: "left" }}
									>
										{item.name}
									</Heading>
									<Text
										variant="blogAnswer"
										textAlign={{ xs: "center", sm: "left" }}
										fontStyle="italic"
									>
										{item.position}
									</Text>
								</Flex>
								<Flex
									columnGap={{ xs: "4px", md: "16px" }}
									justifyContent={{ xs: "center", sm: "flex-start" }}
									transform={{ xs: "translateX(12px)", sm: "none" }}
								>
									<Box alignSelf="center">
										<Link href={item.linkedin} target="_blank">
											<IconButton
												aria-label="linkedin"
												icon={
													<FaLinkedin
														size="28px"
														color="rgba(100, 100, 140, 0.6)"
													/>
												}
												variant="unstyled"
												cursor="pointer"
											/>
										</Link>
									</Box>
								</Flex>
							</Flex>
						</Flex>
					))}
				</Flex>

				<Box w={{ xs: "100%", md: "73%" }}>
					<Text variant="blogAnswer" mb="20px">
						Aavishkaar, a pioneering impact fund manager that does multi-stage
						investing, recently saw its fourth seed to IPO story play out with
						the listing of Utkarsh Small Finance Bank. Every success has a good
						story behind it, and here is an attempt to share our thinking behind
						the investment and what kept us going till the IPO and further.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						All seed investments are made with the belief of great unrealized
						potential. The challenge with potential is that it does not get
						realized often, and hence, seed investors are unsure of how long to
						stick out with their early investments.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Aavishkaar’s journey started in early 2000, and given the very
						scarce follow-on markets, our focus used to be on sustainability and
						profitability at the start-up. All capital raises were directed
						toward securing the company and its growth, and secondaries for
						seed/angel investors or for promoters were not even on the
						discussion table.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						In early 2000, our investment decisions were both similar and
						different to current VC decision-making in the broader investing
						market. The difference extended not just to how we operated but also
						to the manner we imagined the future of the company.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Like every generation of VCs, the management team and its founder
						leader were key diligence items for us and consumed most of our
						time, but when it came to the business model, our diligence used to
						focus on profitability (a term that lost its relevance for some time
						but has found its mojo back post-2021) and sustainability of scale.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						In 2009, when I met the founder of Utkarsh Small Finance Bank, we
						were seeking out a trustworthy leader from banking or finance around
						whom we could build an incubated start-up in microfinance in Eastern
						UP to scale and build market credibility for low-income states as a
						destination for microfinance.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						In Govind Singh, we thought we found a person who was credible and
						trustworthy and a worthy partner. Our diligence needed us to find
						verifiable evidence of his ability to be long term, be decisive, and
						act speedily. We put a few conditions in front of him, and I share
						those conditions and our thinking behind those questions:
					</Text>
					<UnorderedList>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								If you are convinced about the opportunity, would you be willing
								to quit your job without any commitment to our capital?
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							The purpose of the question was to test his conviction in the idea
							and if he was decisive enough. We wanted to be his support but not
							his crutch.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Could you convince a couple of senior folks from your current
								employer to invest money in this adventure?
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							We wanted to see if his bosses trusted him with their personal
							money and gauge his credibility within the system he operated.
						</Text>

						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Could you invest your personal savings in buying a non-banking
								finance company without our capital commitment behind you?
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							We were keen to see if the person was willing to take a very large
							risk to make their dream come true.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Please keep the head office of the company in Varanasi and build
								a business there, as it has a high density of poverty.
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							We knew microfinance needs a hands-on business leader and not
							someone who wants to play golf every evening. For us, Varanasi was
							a location we felt would give him an edge. We wanted to see if he
							is rational when his professional and personal interests collide.
						</Text>
					</UnorderedList>
					<Text variant="blogAnswer" pb="20px">
						Govind nodded and left my office, only to come back after completing
						all the tasks in a period of four months. He never once sought
						further assurance, and thus, we built a relationship of mutual trust
						and have kept backing Govind and Utkarsh through thick and thin.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Once we made our decision, we defined our role as cheerleaders,
						supporters, and personal advisors to Govind. We decided to intervene
						only if the institution needed it. Govind made sure no investor was
						ever surprised by any development in the business, and when it
						happened, it was not under his control.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Immediately after our investment, Govind walked into the
						microfinance crisis of 2010, and we were forced to invest in Utkarsh
						again to keep our promise of trust going.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Utkarsh has seen many crises since its infancy and has slowly grown
						to become a strong microfinance institution. Finally, Utkarsh got an
						opportunity to become a banker in 2016. This was a major pivot, and
						we supported the transition with more capital and commitment.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						As the institution prepared to become a bank, it kept getting hit
						with new risks such as demonetization, and just when it was ready to
						go for IPO, COVID struck and thwarted all plans for the IPO. As the
						COVID impact forced Govind to raise more capital, Aavishkaar this
						time decided to come in and participate in the bank as well.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						While the narrative sounds like a bold decision to back the
						institution, in reality, we made our choices early about the sector,
						the entrepreneur, and the potential for scale. Post that, our
						decisions were driven by opportunity and ability, and our desire to
						support scale was backed by our trust in the leadership.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						As I conclude, I would like entrepreneurs to keep in mind that the
						seed to IPO journey is a long one and has many ups and downs. You
						need a village to raise the venture baby, so surround yourself with
						people who can support you when the chips are down and cheer for you
						when you achieve success.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						To investors, I would say that make your choices early and back the
						leadership to help build scalable companies that deliver success and
						IPO.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						And in general, my closing statement is that an IPO is a minor pit
						stop in the journey of building an institution that lasts beyond the
						leader, the investors, and everyone involved. The ultimate goal for
						all of us is to build a lasting legacy of great institutions that
						can deliver impact, scale, and return.
					</Text>
				</Box>
			</Flex>
			<Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
			<Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
				<Heading variant="blogQuestion" fontStyle="normal" as="span">
					#TheContext by IVCA{" "}
				</Heading>
				– features opinion makers from the alternate investing industry with
				strong focus on India as investment destination. Watch this space for
				viewpoints on investment themes, emerging trends, economic analysis and
				latest industry insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with &nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextSeedBlog;
